/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRequestAutocompleteSuggestion } from './APIRequestAutocompleteSuggestion';
import {
    APIRequestAutocompleteSuggestionFromJSON,
    APIRequestAutocompleteSuggestionFromJSONTyped,
    APIRequestAutocompleteSuggestionToJSON,
} from './APIRequestAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIRequestAutocompleteResponse
 */
export interface APIRequestAutocompleteResponse {
    /**
     * 
     * @type {Array<APIRequestAutocompleteSuggestion>}
     * @memberof APIRequestAutocompleteResponse
     */
    suggestions: Array<APIRequestAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIRequestAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIRequestAutocompleteResponse interface.
 */
export function instanceOfAPIRequestAutocompleteResponse(value: object): value is APIRequestAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIRequestAutocompleteResponseFromJSON(json: any): APIRequestAutocompleteResponse {
    return APIRequestAutocompleteResponseFromJSONTyped(json, false);
}

export function APIRequestAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIRequestAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIRequestAutocompleteResponseToJSON(value?: APIRequestAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIRequestAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

